import React, { useState } from 'react';
import AdminAppBody from '../../../components/admin/AdminAppBody';
import PageHeading from '../../../components/admin/common/PageHeading';
import { FaEye, FaEdit, FaTrash, FaSearch } from 'react-icons/fa';

const usersData = [
    { id: 1, name: 'John Doe', email: 'john@example.com', location: 'New York', mobile: '123-456-7890', avatar: 'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg' },
    { id: 2, name: 'Aisha Khan', email: 'aisha@example.com', location: 'London', mobile: '234-567-8901', avatar: 'https://images.pexels.com/photos/1462633/pexels-photo-1462633.jpeg' },
    { id: 3, name: 'Li Wei', email: 'liwei@example.com', location: 'Beijing', mobile: '345-678-9012', avatar: 'https://images.pexels.com/photos/3793238/pexels-photo-3793238.jpeg' },
    { id: 4, name: 'Carlos Martinez', email: 'carlos@example.com', location: 'Madrid', mobile: '456-789-0123', avatar: 'https://images.pexels.com/photos/1704488/pexels-photo-1704488.jpeg' },
    { id: 5, name: 'Sara Kim', email: 'sara@example.com', location: 'Seoul', mobile: '567-890-1234', avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg' },
    { id: 6, name: 'Ahmed Ali', email: 'ahmed@example.com', location: 'Cairo', mobile: '678-901-2345', avatar: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg' },
    { id: 7, name: 'Emily Smith', email: 'emily@example.com', location: 'Toronto', mobile: '789-012-3456', avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg' },
    { id: 8, name: 'Raj Patel', email: 'raj@example.com', location: 'Mumbai', mobile: '890-123-4567', avatar: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg' },
    { id: 9, name: 'Yuki Tanaka', email: 'yuki@example.com', location: 'Tokyo', mobile: '901-234-5678', avatar: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg' },
    { id: 10, name: 'Michael Brown', email: 'michael@example.com', location: 'Los Angeles', mobile: '012-345-6789', avatar: 'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg' },
    { id: 11, name: 'Fatima Noor', email: 'fatima@example.com', location: 'Dubai', mobile: '111-222-3333', avatar: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg' },
    { id: 12, name: 'William Lee', email: 'william@example.com', location: 'Singapore', mobile: '222-333-4444', avatar: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg' },
    { id: 13, name: 'Nina Petrova', email: 'nina@example.com', location: 'Moscow', mobile: '333-444-5555', avatar: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg' },
    { id: 14, name: 'Pedro Gomez', email: 'pedro@example.com', location: 'Santiago', mobile: '444-555-6666', avatar: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg' },
    { id: 15, name: 'Zara Rahman', email: 'zara@example.com', location: 'Dhaka', mobile: '555-666-7777', avatar: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg' },
];

const List = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [locationFilter, setLocationFilter] = useState('');

    const filteredUsers = usersData.filter(user =>
        (user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase())) &&
        (locationFilter ? user.location === locationFilter : true)
    );

    const uniqueLocations = [...new Set(usersData.map(user => user.location))];

    return (
        <AdminAppBody
            content={
                <div className="container">
                    <PageHeading
                        title="User List"
                        subTitle="Manage all registered users with their roles and statuses."
                    />
                    <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
                        <div className="px-4 py-3 border-bottom bg-white">
                            <div className="row align-items-center">
                                <div className="col-md-3">
                                    <h5 className="mb-0 fw-semibold">Users</h5>
                                </div>
                                <div className="col-md-5">
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0">
                                            <FaSearch />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0"
                                            placeholder="Search by name or email"
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        className="form-select"
                                        value={locationFilter}
                                        onChange={e => setLocationFilter(e.target.value)}
                                    >
                                        <option value="">Filter by location</option>
                                        {uniqueLocations.map((loc, idx) => (
                                            <option key={idx} value={loc}>
                                                {loc}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-hover align-middle sys-list-table__content">

                                <thead className="bg-light text-dark text-uppercase small">
                                    <tr>
                                        <th className="px-4 py-2">Sr No.</th>
                                        <th className="px-4 py-2">User</th>
                                        <th className="px-4 py-2">Email</th>
                                        <th className="px-4 py-2">Mobile</th>
                                        <th className="px-4 py-2">Location</th>
                                        <th className="px-4 py-2 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredUsers.map((user, index) => (
                                        <tr key={user.id} className="sys-list-table__row border-bottom">
                                            <th className="px-4 py-2">{index + 1}</th>
                                            <td className="px-4 py-2">
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={user.avatar}
                                                        alt={`${user.name}'s avatar`}
                                                        className="rounded-circle me-3"
                                                        style={{ width: '36px', height: '36px', objectFit: 'cover' }}
                                                    />
                                                    <span className="fw-medium">{user.name}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-2">{user.email}</td>
                                            <td className="px-4 py-2">{user.mobile}</td>
                                            <td className="px-4 py-2">{user.location}</td>
                                            <td className="px-4 py-2 text-center">
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className="sys-list-table__action view" title="View User">
                                                        <FaEye />
                                                    </button>
                                                    <button className="sys-list-table__action edit" title="Edit User">
                                                        <FaEdit />
                                                    </button>
                                                    <button className="sys-list-table__action delete" title="Delete User">
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Search & Filter Section */}

                </div>
            }
        />
    );
};

export default List;
